export const TEST_TOOL_ID = 'test';
